import { http } from "@/configurations/axios";

const post = (url, payload = {}) => http.post(url, payload);

export default {
  dashboard(params = {}) {
    return post("/crm/dashboard", params);
  },
  kanban(params = {}) {
    return post("/crm/oportunidades/kanban", params);
  },
  criarContato(payload) {
    return post("/crm/contatos/create", payload);
  },
  vincularPessoaContato(payload) {
    return post("/crm/contatos/link-person", payload);
  },
  criarOportunidade(payload) {
    return post("/crm/oportunidades/create", payload);
  },
  detalheOportunidade(params = {}) {
    return post("/crm/oportunidades/find", params);
  },
  atualizarOportunidade(payload) {
    return post("/crm/oportunidades/update", payload);
  },
  moverEtapa(payload) {
    return post("/crm/oportunidades/mover-etapa", payload);
  },
  marcarGanha(payload) {
    return post("/crm/oportunidades/marcar-ganha", payload);
  },
  marcarPerdida(payload) {
    return post("/crm/oportunidades/marcar-perdida", payload);
  },
  motivosPerda() {
    return post("/crm/oportunidades/motivos-perda");
  },
  fontes() {
    return post("/crm/oportunidades/fontes");
  },
  contatosAutocomplete(params = {}) {
    return post("/crm/contatos/autocomplete", params);
  },
  pessoasAutocomplete(params = {}) {
    return post("/crm/contatos/pessoas-autocomplete", params);
  },
  usuarios(params = {}) {
    return post("/usuario/get-usuarios", params);
  },
  criarAtividade(payload) {
    return post("/crm/atividades/create", payload);
  },
  concluirAtividade(payload) {
    return post("/crm/atividades/concluir", payload);
  },
  adiarAtividade(payload) {
    return post("/crm/atividades/adiar", payload);
  },
  atividades(params = {}) {
    return post("/crm/atividades/lista", params);
  },
  lembretesAtividades(params = {}) {
    return post("/crm/atividades/lembretes", params);
  },
  adiarLembreteAtividade(payload) {
    return post("/crm/atividades/snooze", payload);
  },
  marcarNotificacaoVisualizada(payload) {
    return post("/notificacao/update", payload);
  },
  timeline(params = {}) {
    return post("/crm/timeline/lista", params);
  },
  adicionarNota(payload) {
    return post("/crm/timeline/nota", payload);
  },
  agenda(params = {}) {
    return post("/crm/agenda/lista", params);
  },
  criarAgendamento(payload) {
    return post("/crm/agenda/create", payload);
  },
  atualizarAgendamento(payload) {
    return post("/crm/agenda/update", payload);
  },
  reagendarAgendamento(payload) {
    return post("/crm/agenda/reagendar", payload);
  },
  cancelarAgendamento(payload) {
    return post("/crm/agenda/cancelar", payload);
  },
  alterarStatusAgenda(payload) {
    return post("/crm/agenda/status", payload);
  },
  solicitacoesTecnicasAgenda(params = {}) {
    return post("/crm/agenda/solicitacoes", params);
  },
  gerarLinkSolicitacaoTecnica(payload) {
    return post("/crm/agenda/solicitacoes/link", payload);
  },
  agendarSolicitacaoTecnica(payload) {
    return post("/crm/agenda/solicitacoes/agendar", payload);
  },
  concluirSolicitacaoTecnica(payload) {
    return post("/crm/agenda/solicitacoes/concluir", payload);
  },
  agendamentosOperacionais(params = {}) {
    return post("/crm/agendamentos/lista", params);
  },
  criarAgendamentoOperacional(payload) {
    return post("/crm/agendamentos/create", payload);
  },
  atualizarAgendamentoOperacional(payload) {
    return post("/crm/agendamentos/update", payload);
  },
  reagendarAgendamentoOperacional(payload) {
    return post("/crm/agendamentos/reagendar", payload);
  },
  cancelarAgendamentoOperacional(payload) {
    return post("/crm/agendamentos/cancelar", payload);
  },
  concluirAgendamentoOperacional(payload) {
    return post("/crm/agendamentos/concluir", payload);
  },
  horariosDisponiveisAgenda(params = {}) {
    return post("/agendamentos/horarios", params);
  },
  gerarLinkHorariosAgenda(payload) {
    return post("/agendamentos/link", payload);
  },
  oportunidades(params = {}) {
    return post("/crm/oportunidades/lista", params);
  },
  tecnicos(params = {}) {
    return post("/tecnico/get-tecnico", params);
  },
  servicos(params = {}) {
    return post("/servicos/filter", params);
  },
  funis(params = {}) {
    return post("/crm/funis/lista", params);
  },
  criarFunil(payload) {
    return post("/crm/funis/create", payload);
  },
  atualizarFunil(payload) {
    return post("/crm/funis/update", payload);
  },
  apagarFunil(payload) {
    return post("/crm/funis/delete", payload);
  },
  atualizarAcessosFunil(payload) {
    return post("/crm/funis/acessos/update", payload);
  },
  criarEtapa(payload) {
    return post("/crm/funis/etapas/create", payload);
  },
  atualizarEtapa(payload) {
    return post("/crm/funis/etapas/update", payload);
  },
  fontesConfiguracao() {
    return post("/crm/configuracoes/fontes/lista");
  },
  criarFonte(payload) {
    return post("/crm/configuracoes/fontes/create", payload);
  },
  atualizarFonte(payload) {
    return post("/crm/configuracoes/fontes/update", payload);
  },
  motivosPerdaConfiguracao() {
    return post("/crm/configuracoes/motivos-perda/lista");
  },
  criarMotivoPerda(payload) {
    return post("/crm/configuracoes/motivos-perda/create", payload);
  },
  atualizarMotivoPerda(payload) {
    return post("/crm/configuracoes/motivos-perda/update", payload);
  },
  tiposTarefaConfiguracao() {
    return post("/crm/configuracoes/tipos-tarefa/lista");
  },
  criarTipoTarefa(payload) {
    return post("/crm/configuracoes/tipos-tarefa/create", payload);
  },
  atualizarTipoTarefa(payload) {
    return post("/crm/configuracoes/tipos-tarefa/update", payload);
  },
  temperaturasConfiguracao() {
    return post("/crm/configuracoes/temperaturas/lista");
  },
  criarTemperatura(payload) {
    return post("/crm/configuracoes/temperaturas/create", payload);
  },
  atualizarTemperatura(payload) {
    return post("/crm/configuracoes/temperaturas/update", payload);
  },
  camposComerciaisConfiguracao() {
    return post("/crm/configuracoes/campos-comerciais/lista");
  },
  criarCampoComercial(payload) {
    return post("/crm/configuracoes/campos-comerciais/create", payload);
  },
  atualizarCampoComercial(payload) {
    return post("/crm/configuracoes/campos-comerciais/update", payload);
  },
  preConfiguracoesConfiguracao(params = {}) {
    return post("/crm/configuracoes/presets/lista", params);
  },
  instalarPresetConfiguracao(payload = {}) {
    return post("/crm/configuracoes/preset/install", payload);
  },
  atribuicoesConfiguracao(params = {}) {
    return post("/crm/configuracoes/atribuicoes/lista", params);
  },
  salvarAtribuicoesConfiguracao(payload = {}) {
    return post("/crm/configuracoes/atribuicoes/salvar", payload);
  },
  usuariosAtribuicoesConfiguracao(params = {}) {
    return post("/crm/configuracoes/atribuicoes/usuarios", params);
  },
  permissaoAtribuicoesConfiguracao(params = {}) {
    return post("/crm/configuracoes/atribuicoes/permissao", params);
  },
  automacoesOpcoes() {
    return post("/crm/configuracoes/automacoes/opcoes");
  },
  automacoes(params = {}) {
    return post("/crm/configuracoes/automacoes/lista", params);
  },
  automacaoDetalhe(params = {}) {
    return post("/crm/configuracoes/automacoes/find", params);
  },
  criarAutomacao(payload) {
    return post("/crm/configuracoes/automacoes/create", payload);
  },
  atualizarAutomacao(payload) {
    return post("/crm/configuracoes/automacoes/update", payload);
  },
  alterarStatusAutomacao(payload) {
    return post("/crm/configuracoes/automacoes/status", payload);
  },
  apagarAutomacao(payload) {
    return post("/crm/configuracoes/automacoes/delete", payload);
  },
  executarAutomacao(payload) {
    return post("/crm/configuracoes/automacoes/executar", payload);
  },
  automacaoExecucoes(params = {}) {
    return post("/crm/configuracoes/automacoes/execucoes", params);
  },
  relatorioFunil(params = {}) {
    return post("/crm/relatorios/funil", params);
  },
  relatorioPerdas(params = {}) {
    return post("/crm/relatorios/perdas", params);
  },
  relatorioProdutividade(params = {}) {
    return post("/crm/relatorios/produtividade", params);
  },
  relatorioOrigens(params = {}) {
    return post("/crm/relatorios/origens", params);
  },
  relatorioAgenda(params = {}) {
    return post("/crm/relatorios/agenda", params);
  },
  relatorioOportunidadesLista(params = {}) {
    return post("/crm/relatorios/oportunidades/lista", params);
  },
  relatorioClientesLista(params = {}) {
    return post("/crm/relatorios/contatos/lista", {
      ...params,
      tipo_relatorio: "clientes",
    });
  },
  relatorioContatosLista(params = {}) {
    return post("/crm/relatorios/contatos/lista", params);
  },
  relatorioTarefasLista(params = {}) {
    return post("/crm/relatorios/atividades/lista", params);
  },
  relatorioAgendaLista(params = {}) {
    return post("/crm/relatorios/agenda/lista", params);
  },
  relatorioSolicitacoesAgenda(params = {}) {
    return post("/crm/relatorios/agenda/solicitacoes", params);
  },
};
